export default {
  drinks: "BEBIDAS",
  food: "COMIDA",
  dessert: "POSTRE",
  first: "Primero",
  second: "Segundo",
  mainCourses: "PLATOS PRINCIPALES",
  comments: "Comentarios:",
  invoice: "Factura",
  cookies: "Cookies",
  privacy: "Privacidad",
  termsAndConditions: "Términos y condiciones",
  noRecordMessage:
    "No se han encontrado resultados. Por favor, revisa los filtros de búsqueda!",
  askFor: "Pedir",
  keep: "Guardar",
  close: "Cerrar",
  everything: "Todo",
  done: "Hecho",
  toShare: "A COMPARTIR",
  companyName: "Nombre/Empresa",
  postalCode: "Código Postal",
  town: "Ciudad",
  address: "Dirección",
  nameIsRequired: "Nombre es requerido",
  addressIsRequired: "Dirección es requerido",
  NIFIsRequired: "NIF es requerido",
  postalCodeIsRequired: "Código Postal es requerido",
  cityIsRequired: "Ciudad es requerido",
  emailIsRequired: "Correo electronico es requerido",
  theEmailMustBeValid: "El email debe ser válido",
  charging: "Cargando..."
};
